import React from "react";
import { Link } from "react-router-dom";

// Case study images
import caproCase from "../../images/blog/capro-case.png";
import medflowCaseV2 from "../../images/blog/medflow-case-v2.png";
import vaproCase from "../../images/blog/vapro-case.png";
import saproCase from "../../images/blog/sapro-case.png";
import haproCase from "../../images/blog/hapro-case.png";

interface CaseStudy {
  id: number;
  product: string;
  tags: string[];
  title: string;
  description: string;
  image: string;
}

const caseStudies: CaseStudy[] = [
  {
    id: 1,
    product: "CAPRO",
    tags: ["AI Voice Agent", "Healthcare", "Automation"],
    title: "MedFlow Health: 60% Reduction in Missed Appointments",
    description:
      "Deployed CAPRO to automate patient scheduling and follow-ups, resulting in dramatic improvements in appointment adherence. The AI agent handles 400+ calls monthly, confirms appointments, and reschedules cancellations, reducing no-shows by 60% in the first quarter.",
    image: medflowCaseV2,
  },
  {
    id: 2,
    product: "VAPRO",
    tags: ["Social Media AI", "Content", "Engagement"],
    title: "Urban Eats: 340% Social Media Engagement Increase",
    description:
      "VAPRO autonomously managed content creation and posting across 4 social platforms, driving unprecedented engagement growth. Within 90 days, follower count grew 2.5x and inbound leads from social channels increased by 180%.",
    image: vaproCase,
  },
  {
    id: 3,
    product: "SAPRO",
    tags: ["Sales AI", "Lead Gen", "Real Estate"],
    title: "Pinnacle Real Estate: 3x Lead Qualification Rate",
    description:
      "SAPRO engaged and qualified leads 24/7 across multiple channels, tripling the sales pipeline within the first month. The AI agent made 2,000+ outbound calls monthly, booking 45% more property viewings than the previous manual process.",
    image: saproCase,
  },
  {
    id: 4,
    product: "HAPRO",
    tags: ["HR Automation", "AI Interviews", "Recruitment"],
    title: "TechScale: Hiring Time Reduced from 14 Days to 2",
    description:
      "HAPRO streamlined candidate screening with AI-driven interviews, dramatically accelerating the hiring pipeline. Over 500 candidates were screened in the first month, with interview-to-offer conversion improving by 35%.",
    image: haproCase,
  },
];

const BlogList: React.FC = () => {
  return (
    <section className="blog-page-section pt-150 pb-150">
      <div className="container">
        {/* Section Header - Master Design System Pattern */}
        <div className="sec-title sec-title-center text-center mb-70">
          <span className="sub-title mb-15">Case Studies</span>
          <h2 className="title">
            Deployed. Measured. Proven.
          </h2>
        </div>

        <div className="row">
          {caseStudies.map((study, index) => (
            <div className="col-lg-12 mt-30" key={study.id}>
              {/* Blog Item - Master Design System Pattern */}
              <div className="xb-blog-item">
                <div className="xb-item--inner xb-border img-hove-effect">
                  <div className={`row align-items-center ${index % 2 !== 0 ? 'flex-row-reverse text-end' : ''}`}>
                    {/* Image Column */}
                    <div className="col-lg-6">
                      <div className="xb-img">
                        <img src={study.image} alt={study.title} />
                      </div>
                    </div>

                    {/* Content Column */}
                    <div className="col-lg-6">
                      <div className="xb-item--holder p-4 p-lg-5">
                        <div className={`xb-item--tags mb-20 ${index % 2 !== 0 ? 'justify-content-end' : ''} d-flex flex-wrap gap-2 align-items-center`}>
                          <span className="xb-item--tag" style={{ background: 'var(--color-primary)', color: '#fff', padding: '4px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>
                            {study.product}
                          </span>
                          {study.tags.map((tag, i) => (
                            <span key={i} className="xb-item--tag" style={{ fontSize: '14px', opacity: 0.7 }}>#{tag.toLowerCase().replace(/ /g, '')}</span>
                          ))}
                        </div>
                        
                        <h2 className="xb-item--title">
                          {study.title}
                        </h2>
                        
                        <p className="xb-item--content mt-20" style={{ color: 'var(--color-white)', opacity: 0.8 }}>
                          {study.description}
                        </p>


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogList;
